import { LanguageSelector } from '@gn-audio/jss-components';

export default LanguageSelector;
